import 'jquery-drawer'

declare global {
  interface JQuery {
    drawer(): JQuery
  }
}


export function initNoteDrawer(): void {
  const $drawer = $('#note-drawer')
  if (!$drawer.length) return

  $drawer.drawer()

  $('#open-note-drawer').off('click').on('click', () => {
    $drawer.addClass('drawer-open')
    $('body').addClass('no-scroll')

    clearnoteForm()
    updateNoteDrawerButtons()
  })

  $drawer.find('.note-drawer-close').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
    $('body').removeClass('no-scroll')
  })

  $drawer.find('.drawer-overlay').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
    $('body').removeClass('no-scroll')
  })



  $('#create-note-btn').off('click').on('click', function (e) {
    e.preventDefault()
    const data = {
      customer_id: new URLSearchParams(window.location.search).get('id') || '',
      notes: $('#text-notes').summernote('code')
    }

    const $drawerNav = $('.drawer-nav')
    const $drawerOverlay = $('.drawer-overlay')

    $.ajax({
      url: '/customer_success/create_note',
      method: 'POST',
      data: data,
      beforeSend: function () {
        $drawerNav.css({ 'pointer-events': 'none', 'opacity': 0.9 })
        $drawerOverlay.css({ 'pointer-events': 'none' })

        if ($drawerNav.find('.ajax-loading-spinner').length === 0) {
          const spinner = $(`
            <div class="ajax-loading-spinner">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          `)

          $drawerNav.append(spinner)
        }
      },
      success: function (response) {
        location.reload();
      },
      error: function (xhr) {
        console.error('Failed to create note', xhr.responseText)
      },
      complete: function () {
        $drawerNav.css({ 'pointer-events': '', 'opacity': '' })
        $drawerOverlay.css({ 'pointer-events': '' })
        $drawerNav.find('.ajax-loading-spinner').remove()
      }
    })
  })


  $(document).off('click', '.edit-note-button').on('click', '.edit-note-button', function (event) {
    event.stopPropagation();
    const taskData = {
      id: $(this).data('id'),
      notes: $(this).data('notes'),
    }

    populateNoteForm(taskData)
    updateNoteDrawerButtons(true)

    $drawer.addClass('drawer-open')
    $('body').addClass('no-scroll')
  })

  $('#save-note-btn').off('click').on('click', function (e) {
    e.preventDefault()

    const data = {
      id: $('#note-id').val(),
      notes: $('#text-notes').summernote('code')
    }
    console.log(data.notes + data.id)
    const $drawerNav = $('.drawer-nav')
    const $drawerOverlay = $('.drawer-overlay')

    $.ajax({
      url: '/customer_success/update_note',
      method: 'PATCH',
      data: data,
      beforeSend: function () {
        $drawerNav.css({ 'pointer-events': 'none', 'opacity': 0.9 })
        $drawerOverlay.css({ 'pointer-events': 'none' })

        if ($drawerNav.find('.ajax-loading-spinner').length === 0) {
          const spinner = $(`
            <div class="ajax-loading-spinner">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          `)

          $drawerNav.append(spinner)
        }
      },
      success: function (response) {
        location.reload()
      },
      error: function (xhr) {
        console.error('Failed to save note', xhr.responseText)
      },
      complete: function () {
        $drawerNav.css({ 'pointer-events': '', 'opacity': '' })
        $drawerOverlay.css({ 'pointer-events': '' })
        $drawerNav.find('.ajax-loading-spinner').remove()
      }
    })
  })

  $('#cancel-note-btn').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
  })

  $('#delete-note-btn').off('click').on('click', function () {
    const noteId = $(this).data('note-id')
    const customerId = $(this).data('customer-id')

    console.log(noteId)
    $('#delete-note-id').val(noteId)
    $('#delete-customer-id').val(customerId)

    $('#deleteNoteModal').modal('show')
  })


  const fixedDiv = document.querySelector<HTMLDivElement>('.body-drawer');

  if (fixedDiv) {
    fixedDiv.addEventListener('wheel', (e: WheelEvent) => {
      e.preventDefault();
      fixedDiv.scrollTop += e.deltaY; 
    });
  }
}



function clearnoteForm() {
  $('#text-notes').summernote('code', '')
}
function updateNoteDrawerButtons(isEditMode = false) {
  if (isEditMode) {
    $('#create-note-btn').addClass('d-none')
    $('#save-note-btn, #cancel-note-btn, #delete-note-btn').removeClass('d-none')
    $('#delete-note-btn').attr('data-note-id', $('#note-id').val() as string)
  } else {
    $('#create-note-btn').removeClass('d-none')
    $('#save-note-btn, #cancel-note-btn, #delete-note-btn').addClass('d-none')
  }
}

function populateNoteForm(data: any) {
  $('#note-id').val(data.id)
  $('#text-notes').summernote('code', data.notes || '')
}